import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";

const ButtonHashtag = ({ text, color, onClick, style, fullTitle = null }) => {
  return (
    <Tooltip title={fullTitle ? fullTitle : text} placement="top" arrow>
      <button
        className={`flex flex-row bg-${color}-light hover:opacity-80 rounded-md px-2 py-1 
                        items-center justify-center w-flex ${style}`}
        onClick={onClick}
      >
        <p className={`text-${color}-dark font-semibold text-xs`}>{text}</p>
      </button>
    </Tooltip>
  );
};

ButtonHashtag.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  url: PropTypes.string,
};

export default ButtonHashtag;
